import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3","key":"svg-0"}]]

/**
 * IconSpace
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3BhY2UiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMTB2M2ExIDEgMCAwIDAgMSAxaDE0YTEgMSAwIDAgMCAxIC0xdi0zIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/space
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSpace = createReactComponent('outline', 'space', 'Space', __iconNode);

export default IconSpace;